<template>
  <div class="portal-snackbar-host">
    <v-snackbar
      v-for="(item, i) in snackbarList"
      :key="item.id"
      v-model="item.isOpen"
      :timeout="item.timeout ?? 4000"
      :color="snackbarColor(item.type)"
      location="top"
      multi-line
      transition="scale-transition"
      class="portal-snackbar-item"
      :style="stackStyle(i)"
      @update:model-value="(open) => !open && onSnackbarClosed(item.id)"
    >
      <div class="d-flex align-center portal-snackbar-row w-100">
        <v-icon :icon="getIcon(item.type)" size="28" class="flex-shrink-0 portal-snackbar-row__icon" />
        <div class="flex-grow-1 min-width-0 portal-snackbar-row__text">
          <p class="portal-snackbar-msg mb-0">{{ item.message }}</p>
          <p v-if="item.detail" class="portal-snackbar-detail mb-0">{{ formatDetail(item.detail) }}</p>
        </div>
        <v-btn
          icon
          variant="text"
          density="comfortable"
          color="white"
          class="flex-shrink-0 portal-snackbar-row__close"
          @click="dismiss(item.id)"
        >
          <v-icon :icon="closeIcon" />
        </v-btn>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import enums from '../../utils/enums'

export default {
  name: 'PortalSnackBar',
  data() {
    return {
      snackbarList: [],
      closeIcon: enums.icons.CLOSE,
    }
  },
  computed: {
    ...mapGetters({
      snackBar: 'alerts/alert',
    }),
  },
  watch: {
    snackBar: {
      handler(val) {
        if (val) {
          this.enqueue(val)
        }
      },
      deep: true,
    },
  },
  methods: {
    stackStyle(i) {
      const len = this.snackbarList[i]?.message?.length ?? 0
      let base = 80
      if (len >= 128) base = 120
      else if (len >= 30) base = 100
      return { marginTop: `${i * base}px` }
    },
    enqueue(alert) {
      const item = {
        ...alert,
        isOpen: true,
      }
      const repeatedIndex = this.snackbarList.findIndex((x) =>
        this.sameAlert(x, item)
      )
      if (repeatedIndex !== -1) {
        this.snackbarList.splice(repeatedIndex, 1, item)
        return
      }
      this.snackbarList.push(item)
    },
    sameAlert(a, b) {
      return (
        a?.type === b?.type &&
        a?.message === b?.message &&
        this.formatDetail(a?.detail) === this.formatDetail(b?.detail)
      )
    },
    dismiss(id) {
      const item = this.snackbarList.find((x) => x.id === id)
      if (item) item.isOpen = false
    },
    onSnackbarClosed(id) {
      this.snackbarList = this.snackbarList.filter((x) => x.id !== id)
    },
    snackbarColor(type) {
      const map = {
        success: 'success',
        error: 'error',
        warning: 'warning',
        info: 'info',
      }
      return map[type] || 'surface-variant'
    },
    getIcon(type) {
      const { icons } = enums
      switch (type) {
        case 'warning':
          return icons.SNB_WARNING
        case 'success':
          return icons.SNB_SUCCESS
        case 'info':
          return icons.SNB_INFO
        case 'error':
          return icons.SNB_ERROR
        default:
          return icons.SNB_INFO
      }
    },
    formatDetail(detail) {
      if (detail == null) return ''
      if (typeof detail === 'string') return detail
      try {
        return JSON.stringify(detail)
      } catch {
        return String(detail)
      }
    },
  },
}
</script>

<style scoped>
.portal-snackbar-row__text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.portal-snackbar-row__icon,
.portal-snackbar-row__close {
  align-self: center;
}
.portal-snackbar-msg {
  font-weight: 500;
  white-space: pre-line;
  line-height: 1.45;
}
.portal-snackbar-detail {
  font-size: 12px;
  margin-top: 4px;
  opacity: 0.9;
}
.min-width-0 {
  min-width: 0;
}
.portal-snackbar-row {
  gap: 12px;
}
</style>
